import { Thumb } from "@/components/tss/CommitteeCard";

export const ResultBars = ({ category, limit, dark = false }) => {
  const rows = limit ? category.rows.slice(0, limit) : category.rows;
  const max = Math.max(1, ...rows.map((r) => r.votes));
  const tid = category.key || category.id;
  return (
    <div data-testid={`results-${tid}`} className={`rounded-2xl border p-4 ${dark ? "border-white/10 bg-white/5" : "border-gold/40 bg-white"}`}>
      <div className="mb-3 flex items-baseline justify-between gap-2">
        <div className="min-w-0">
          <h3 className={`font-display text-lg font-bold ${dark ? "text-gold-light" : "text-maroon"}`}>{category.name_en}</h3>
          <p className={`font-bengali text-sm ${dark ? "text-ivory/70" : "text-ink/70"}`}>{category.name_bn}</p>
        </div>
        <span data-testid={`results-total-${tid}`} className={`shrink-0 text-sm font-semibold ${dark ? "text-ivory/80" : "text-ink-muted"}`}>{category.total} votes</span>
      </div>
      <ol className="space-y-2">
        {rows.map((r, i) => (
          <li key={r.committee_id} className="flex items-center gap-3" data-testid={`results-row-${tid}-${i}`}>
            <span className={`w-5 text-right font-display text-sm font-bold ${i === 0 && r.votes ? "text-saffron" : dark ? "text-ivory/50" : "text-ink-muted"}`}>{i + 1}</span>
            <Thumb committee={r} size="h-8 w-8" />
            <div className="min-w-0 flex-1">
              <div className="flex justify-between gap-2 text-sm">
                <span className={`truncate font-medium ${dark ? "text-ivory" : ""}`}>{r.name}{!r.active && " (inactive)"}</span>
                <span className={`shrink-0 tabular-nums ${dark ? "text-ivory/80" : "text-ink-muted"}`}>{r.votes} · {r.pct}%</span>
              </div>
              <div className={`mt-1 h-2 overflow-hidden rounded-full ${dark ? "bg-white/10" : "bg-gold/15"}`}>
                <div className="h-full rounded-full bg-gradient-to-r from-maroon to-gold transition-[width] duration-700" style={{ width: `${(r.votes / max) * 100}%` }} />
              </div>
            </div>
          </li>
        ))}
        {!rows.length && <li className="text-sm opacity-60">No committees yet.</li>}
      </ol>
    </div>
  );
};
